import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from "react";
import { TooltipContext } from "./Tooltip.js";
import { useTooltip } from "./useTooltip.js";
/**
 * Design-system tooltip trigger: wraps an element and shows the {@link Tooltip}
 * child while the pointer rests on it or keyboard focus is inside it, using
 * {@link useTooltip}. The wrapper is a real element so the trigger need not forward
 * refs and disabled controls still get a tooltip. While open, the wrapper is linked
 * to the bubble with `aria-describedby`, and Escape closes it.
 *
 * @example
 * <TooltipTrigger placement="right">
 *   <IconButton aria-label="Settings" />
 *   <Tooltip>Settings</Tooltip>
 * </TooltipTrigger>
 */
export const TooltipTrigger = ({ as: Wrapper = "div", block = false, focusable = false, children, "data-testid": testId, ...options }) => {
    const id = useId();
    const { open, placement, origin, interactive, triggerProps, bubbleProps } = useTooltip(options);
    return (_jsx(TooltipContext.Provider, { value: { open, id, anchor: open ? triggerProps.ref.current : null, placement, origin, interactive, bubbleProps }, children: _jsx(Wrapper, { ...triggerProps, "data-artis-ui": true, "data-testid": testId, "data-block": block || undefined, tabIndex: focusable ? 0 : undefined, "aria-describedby": open ? id : undefined, className: block ? "block w-full" : "inline-flex items-center", children: children }) }));
};
//# sourceMappingURL=TooltipTrigger.js.map